import React from "react";
import { UserInterface } from "../../../../store/mine_craft/usersSlice";
import { formattedDate } from "../../../../helpers/DateHelpers";

import Title from "./_Title";
import Meta, { MetaInterface } from "../../../../componets/Meta";
import { UserOutlined } from "@ant-design/icons";

interface _MetaInterface {
  user: UserInterface | undefined;
  size?: MetaInterface['size'];
  shape?: MetaInterface['shape'];
  about?: boolean;
  className?: string;
}

const _Meta = ({ user, shape, size, about, className }: _MetaInterface) => {
  if (!user) {
    return null;
  }

  const renderDescription = () => (
    <>
      <small>{`Seen: ${formattedDate(user.current_sign_in_at).fromNow}`}</small>
      {about && <div className='v-user-about'>{user.about_me}</div>}
    </>
  )

  return (
    <Meta
      url={user.url}
      size={size}
      shape={shape}
      avatar={user.avatar_url}
      fallback={UserOutlined}
      badge={user.is_online ? 'green' : 'red'}
      title={<Title name={user.name} bannedUntil={user.banned_until} mutedUntil={user.muted_until} />}
      description={renderDescription()}
      className={className}
    />
  );
}

export default _Meta;
